import { Card, CardContent, withStyles } from "@material-ui/core"
import MailIcon from "@material-ui/icons/Mail"
import RouterIcon from "@material-ui/icons/SettingsRemote"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchUserIntegrations } from "../../../actions/integrationActions"
import { fetchModelClasses } from "../../../actions/modelActions"
import { IntegrationPlatforms } from "../../../util/constants"
import ItemList from "../../Common/ItemList"
import ErrorSnackbar from "../../Common/snackbars/ErrorSnackbar"
import RequestSnackbar from "../../Common/snackbars/RequestSnackbar"
import IntegrationItem from "./IntegrationItem"

const styles = (theme) => ({
  integrationInfoCard: {
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: "20px",
    marginTop: theme.spacing(2),
    padding: 0,
  },
  cardContent: {
    padding: "0!important",
    margin: 0,
  },
})

const Integrations = (props) => {
  const { classes } = props

  const dispatch = useDispatch()

  const [filteredClasses, setFilteredClasses] = useState({})
  const [loading, setLoading] = useState(true)
  const [snackbarMessage, setSnackbarMessage] = useState("")
  const [snackbarOpen, setSnackbarOpen] = useState(false)

  const integrations = useSelector((state) => state.userIntegrations.platforms)
  const integrationData = useSelector((state) => state.userIntegrations.platformData)
  const updated = useSelector((state) => state.userIntegrations.integrationsUpdated)
  const result = useSelector((state) => state.userIntegrations.result)
  const deviceModelData = useSelector((state) => state.device.deviceModelData)
  const modelClasses = useSelector((state) => state.model.modelClasses)
  const groupData = useSelector((state) => state.group.groupData)

  const snackbarMessageController = (message) => {
    setSnackbarMessage(message)
    setSnackbarOpen(true)
  }

  useEffect(() => {
    dispatch(fetchUserIntegrations())
  }, [dispatch])

  useEffect(() => {
    if (updated) {
      dispatch(fetchUserIntegrations())
    }
  }, [updated, dispatch])

  useEffect(() => {
    if (result && result !== "BEGINNING") {
      setLoading(false)
    } else {
      setLoading(true)
    }
  }, [result])

  useEffect(() => {
    const algSet = new Set([...deviceModelData.map((data) => data.alg_id)])
    for (const algId of [...algSet]) {
      if (!(algId in modelClasses)) {
        dispatch(fetchModelClasses(algId))
      }
    }
  }, [deviceModelData, dispatch, modelClasses])

  useEffect(() => {
    if (deviceModelData && modelClasses) {
      const updatedClasses = {}
      const algIds = deviceModelData.map((model) => model.alg_id.toString())
      for (const key of Object.keys(modelClasses)) {
        if (algIds.includes(key)) {
          updatedClasses[key] = modelClasses[key]
        }
      }
      setFilteredClasses(updatedClasses)
    }
  }, [modelClasses, deviceModelData])

  const items = [
    <IntegrationItem
      key={IntegrationPlatforms.GUNDI}
      icon={<RouterIcon />}
      platform={IntegrationPlatforms.GUNDI}
      text={
        integrations.includes(IntegrationPlatforms.GUNDI_V2)
          ? "Gundi v1 - Mutually Exclusive with Gundi v2"
          : "Gundi v1"
      }
      loading={loading}
      availableClasses={filteredClasses}
      availableGroups={groupData}
      integrationData={integrationData.gundi}
      hasIntegration={integrations.includes(IntegrationPlatforms.GUNDI)}
      shouldDisable={integrations.includes(IntegrationPlatforms.GUNDI_V2)}
    />,
    <IntegrationItem
      key={IntegrationPlatforms.GUNDI_V2}
      icon={<RouterIcon />}
      platform={IntegrationPlatforms.GUNDI_V2}
      text={
        integrations.includes(IntegrationPlatforms.GUNDI)
          ? "Gundi v2 - Mutually Exclusive with Gundi v1"
          : "Gundi v2"
      }
      loading={loading}
      availableClasses={filteredClasses}
      availableGroups={groupData}
      integrationData={integrationData.gundi_v2}
      hasIntegration={integrations.includes(IntegrationPlatforms.GUNDI_V2)}
      shouldDisable={integrations.includes(IntegrationPlatforms.GUNDI)}
    />,
    <IntegrationItem
      key={IntegrationPlatforms.EMAIL}
      icon={<MailIcon />}
      platform={IntegrationPlatforms.EMAIL}
      text="Email"
      loading={loading}
      availableClasses={filteredClasses}
      availableGroups={groupData}
      integrationData={integrationData.email}
      snackbarMessageController={snackbarMessageController}
      shouldDisable={false}
      hasIntegration={integrations.includes(IntegrationPlatforms.EMAIL)}
    />,
  ]

  return (
    <React.Fragment>
      <Card className={classes.integrationInfoCard}>
        <CardContent className={classes.cardContent}>
          <ItemList items={items} />
        </CardContent>
      </Card>
      <RequestSnackbar name="Integration" baseSelector="userIntegrations" />
      <ErrorSnackbar
        message={snackbarMessage}
        snackbarOpen={snackbarOpen}
        setSnackbarOpen={setSnackbarOpen}
      />
    </React.Fragment>
  )
}

export default withStyles(styles)(Integrations)
